import { useRef } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Select from 'components/Select/Select';
import Textarea from 'components/Textarea/Textarea';
import { MANUFACTURE_CONNECTION_TYPE_OPTIONS } from 'constants/dataSets';
import { COMMENT_MANUFACTURE, MANUFACTURE_CONNECTION_TYPE } from 'constants/formFields';
import { DESCRIPTION_LENGTH } from 'constants/general';

import type { IManufactureForm } from '../interfaces/IManufactureForm';

import styles from '../scss/LogicalForm.module.scss';

function ManufactureForm({ control }: IManufactureForm) {
  const { t } = useTranslation();
  const manufactureFormRef = useRef<HTMLDivElement>(null);

  return (
    <div className={styles.container} ref={manufactureFormRef}>
      <div className={styles.row}>
        <div className={styles.field}>
          <Controller
            control={control}
            name={MANUFACTURE_CONNECTION_TYPE}
            render={({ field: { value, onChange } }) => (
              <Select
                className={styles.field}
                options={MANUFACTURE_CONNECTION_TYPE_OPTIONS}
                placeholder={t('valueChainMap.connectionType')}
                value={value ?? ''}
                onChange={onChange}
                menuPosition="absolute"
                placeholderClassName={styles.placeholder}
                modalRef={manufactureFormRef}
                classNameMenu={styles.menuMultiple}
                label={t('valueChainMap.connectionType')}
              />
            )}
          />
        </div>
      </div>
      <div className={styles.row}>
        <Controller
          control={control}
          name={COMMENT_MANUFACTURE}
          render={({ field: { name, value, onChange }, fieldState: { error } }) => (
            <Textarea
              name={name}
              value={value}
              label={t('valueChainMap.comment')}
              placeholder={t('common.typeYourMessage')}
              onChange={(e) => onChange(e.target.value.slice(0, DESCRIPTION_LENGTH))}
              error={error?.message}
              charactersLimit={DESCRIPTION_LENGTH}
            />
          )}
        />
      </div>
    </div>
  );
}

export default ManufactureForm;
